import { useMutation } from "@tanstack/react-query";
import api from "../../../api";
import { toast } from "react-toastify";
import { toastStyles } from "../../../styles/styles";
import { PAGE_CONFIG } from "../config";

export const useUpdateTimeline = (queryClient, theme, onSuccessCallback) => {
    const { mutate: updateTimeline, status: updateStatus, isPending: isUpdating } = useMutation({
        mutationFn: (data) => api.timeline.updateTimeline(data),
        onSuccess: (data) => {
            toast.success(data?.message || 'Timeline updated successfully', { ...toastStyles, theme: theme });
            queryClient.invalidateQueries([PAGE_CONFIG.GET_QUERY_KEY]);
            onSuccessCallback && onSuccessCallback();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || 'Timeline update failed', { ...toastStyles, theme: theme });
        }
    });

    return { updateTimeline, isUpdating, updateStatus };
}